import { Box, styled, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { baseColors } from 'utils/constants';

import compensationImage from 'assets/images/top/compensation.png';

const FlowSpan = styled('span')(({ theme }) => ({
  background: `linear-gradient(transparent 60%, ${baseColors.yellow} 30%)`,
  display: 'inline-block'
}));
const BoldSpan = styled('span')`
  font-weight: 700;
`;
function createData(date: string, price: React.ReactNode) {
  return { date, price };
}
const tableRows = [
  createData('1泊2日(2日間)', '¥88'),
  createData('6泊7日(7日間)', '¥308'),
  createData(
    '14泊15日(15日間)',
    <FlowSpan style={{ color: baseColors.black }}>
      <BoldSpan>¥440</BoldSpan>
    </FlowSpan>
  ),
  createData(
    '29泊30日(30日間)',
    <FlowSpan style={{ color: baseColors.black }}>
      <BoldSpan>¥440</BoldSpan>
    </FlowSpan>
  )
];

const CompensationBlock = () => {
  return (
    <Box sx={{ textAlign: 'center', width: { xs: '100%', sm: '600px' }, margin: '0 auto' }}>
      <Box
        component="img"
        src={compensationImage}
        alt="安心補償"
        sx={{
          margin: '15px auto',
          width: { xs: '165px', sm: '300px' },
          height: 'auto' // 画像の比率を保つ
        }}
      />
      <Typography variant="body1" sx={{ fontSize: { xs: '18px', sm: '20px' }, fontWeight: 'bold' }}>
        水没・落下は
        <FlowSpan style={{ fontSize: '22px', fontWeight: 'bold', color: baseColors.red }}>全額補償</FlowSpan>
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '18px', fontWeight: 'bold' }}>
        付属品の紛失・破損は全額補償
      </Typography>
      <Typography variant="body1" sx={{ padding: '10px 0', fontSize: { xs: '12px', sm: '14px' } }}>
        ※万が一盗難・紛失は16,500円（税込）をお客様負担
        <br />
        ※安心補償未加入時は端末代金44,000円（税込）をお客様負担
      </Typography>
      <TableContainer component={Box} sx={{ width: { xs: '100%', sm: '600px' }, margin: '10px auto' }}>
        <Table
          sx={{ width: { xs: '100%', sm: '600px' }, minWidth: { xs: '375px', sm: '650px' }, fontSize: '16px' }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: baseColors.orange, color: baseColors.white }}>
              <TableCell align="center" sx={{ width: { xs: '200px', sm: '350px' } }}>
                日数
              </TableCell>
              <TableCell align="center">料金</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.map((row) => (
              <TableRow
                key={row.date}
                sx={{
                  fontSize: '16px',
                  borderBottom: `1px solid ${baseColors.lineGray}`,
                  '&:last-child td, &:last-child th': { border: 0 }
                }}
              >
                <TableCell align="center" sx={{ backgroundColor: baseColors.lightOrange }} component="th" scope="row">
                  {row.date}
                </TableCell>
                <TableCell align="center">{row.price}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default CompensationBlock;
